import script from "./async-render-error.vue?vue&type=script&setup=true&lang=ts"
export * from "./async-render-error.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__